import type { User } from '@/types';

export function splitDisplayName(displayName: string): { firstName: string; lastName: string } {
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { firstName: '', lastName: '' };
  if (parts.length === 1) return { firstName: parts[0], lastName: '' };
  return { firstName: parts[0], lastName: parts.slice(1).join(' ') };
}

export function resolveProfileNames(user: User): { firstName: string; lastName: string } {
  const firstName = user.firstName?.trim() ?? '';
  const lastName = user.lastName?.trim() ?? '';

  if (firstName || lastName) {
    return { firstName, lastName };
  }

  if (user.displayName?.trim()) {
    return splitDisplayName(user.displayName);
  }

  return { firstName: '', lastName: '' };
}

export function fullNameFromParts(firstName: string, lastName: string): string {
  return [firstName.trim(), lastName.trim()].filter(Boolean).join(' ');
}

export function profileInitials(user: Pick<User, 'firstName' | 'lastName' | 'displayName' | 'phone'>) {
  const { firstName, lastName } = resolveProfileNames(user as User);
  const fromName = [firstName[0], lastName[0]].filter(Boolean).join('');
  if (fromName) return fromName.toUpperCase();
  return (user.phone?.[0] ?? user.displayName?.[0] ?? 'U').toUpperCase();
}
